import React, { Component } from 'react';

export default class VisualizaHistoricoDacaReserva extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render() {
		const {
			props: {
				transacao,
			},
		} = this;

		return (
			<div className='col-12 d-flex flex-column pl-0 pr-0'>
				<div className='d-flex col-12 pl-0 pr-0'>
					<div className='col-6'>
						<strong>Item: </strong>
						<p>{transacao.daca.nome}</p>
					</div>
					<div className='col-6'>
						<strong>Tipo de transação: </strong>
						<p>Reserva - PDR</p>
					</div>
				</div>

				<div className='d-flex col-12 pl-0 pr-0'>
					<div className='col-6'>
						<strong>Tipo de estoque: </strong>
						<p>{transacao.origem}</p>
					</div>
					<div className='col-6'>
						<strong>Quantidade: </strong>
						<p>{transacao.quantidadeEntradaSaida}</p>
					</div>
				</div>

				<div className='d-flex col-12 pl-0 pr-0'>
					<div className='col-6'>
						<strong>Evento: </strong>
						<p>{transacao.ocorrencia.eventoAdverso.nome}</p>
					</div>
					<div className='col-6'>
						<strong>Município: </strong>
						<p>{transacao.destinoMunicipio.nome}</p>
					</div>
				</div>

				<div className='d-flex col-12 pl-0 pr-0'>
					<div className='col-6'>
						<strong>Data do evento: </strong>
						<p>{transacao.ocorrencia.data}</p>
					</div>
					<div className='col-6'>
						<strong>Data da reserva: </strong>
						<p>{transacao.dataCadastro}</p>
					</div>
				</div>
			</div>
		);
	}
}
